import Util from '../utils/util.js';
import { reinitializeSelect2 } from "../utils/forms.js";
import { webformIsDisabled } from '../utils/webform.js';
import { preserveUnsavedState } from '../utils/beforeunload.js';

if (window.site_type && window.site_type === 'cobre') {

/**********************************************************
 * Background Module
 **********************************************************/

function onReadyModuleBackground() {
    let j_months_worked = $('#months_worked');
    if (j_months_worked.length && !j_months_worked.prop('disabled') /* don't do anything if form is disabled (submitted) */) {
        j_months_worked.change(function() {
            let j_over_160 = $('#hours_worked_over_160');
            if (j_months_worked.val() >= 2) {
                $('#hours_worked_over_160_hidden').remove();
                j_over_160.val('Yes');
                j_over_160.prop('disabled', true);
                // Add a hidden element so it submits, as disabled inputs do not submit
                j_over_160.after('<div id="hours_worked_over_160_hidden"><input type="hidden" name="hours_worked_over_160" value="Yes">' +
                    '<div style="margin-bottom:0" class="alert alert-info">This field has been set to "Yes" since you selected 2 or more months worked.</div></div>')
            } else {
                j_over_160.prop('disabled', false);
                $('#hours_worked_over_160_hidden').remove();
            }
        });
        j_months_worked.change();
    }

    if (!$('#is_participant').val()) {
        $(
            'option[value="background_project_role----graduate_student_research_assistant"],' +
            'option[value="background_project_role----undergraduate_student"],' +
            'option[value="background_project_role----technical_school_student"],' +
            'option[value="background_project_role----high_school_student"],' +
            'option[value="background_project_role----reu_participant"]', '#project_role').remove();
    }

    let j_graduation_section = $('.webform_element_graduation_semester');
    $('#role').change(function() {
        if ($.inArray($(this).val(), [
                'background_project_role----graduate_student_research_assistant',
                'background_project_role----undergraduate_student',
                'background_project_role----technical_school_student',
                'background_project_role----high_school_student',
                'background_project_role----reu_participant']) == -1) {
            j_graduation_section.hide();
        } else {
            j_graduation_section.show();
        }
    });
    $('#role').change();
}

/**********************************************************
 * Researchers(Roster) Module
 **********************************************************/

function onReadyResearchersSubform() {
    if (webformIsDisabled()) {
        $('#search_researchers').remove();
        return;
    }

    // Handle search
    let id = $('.webform input[name="id"]').val();
    if (id) {
        $('#search-section').removeClass('in');
    } else {
        $('#search-section').addClass('in');
    }

    $('#search_researchers').typeahead({}, {
        name: 'search_researchers',
        displayKey: 'name',
        source: function(query, sync, async) {
            console.log('searching')
            $.ajax(window['public_path'] + '/researchers/search/' + query, {dataType: 'json'})
             .success(function(result) {
                 async(result);
             });
        },
        templates: {
            suggestion: function (t) {
                return '<div><div class="name">'+(t.name||'')+'</div><div class="email">'+(t.email||'')+'</div></div>';
            }
        }
    }).on('typeahead:select typeahead:autocomplete', function($e, datum) {
        Util.setFromJson(datum);
    });
}

/**********************************************************
 * Publications Module
 **********************************************************/

function publicationArrangeFields(type)
{
    if (type == 'book_chapter') {
        $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#book_edition').parents('.form-group'));
    } else {
        $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#publication_date').parents('.form-group'));
    }
    if ($.inArray(type,['conference_paper_or_proceeding','presentation','other']) !== -1) {
        $('#publication_date').parents('.form-group').insertBefore($('#status').parents('.form-group'));
    } else {
        $('#publication_date').parents('.form-group').insertBefore($('#publication_location').parents('.form-group'));
    }
}

function publicationModifyFields(type)
{
    // Set title (field #2)
    switch (type) {
        case "journal_article":
            $("label[for='title']").text('Article Title');
            break;
        case "book":
        case "book_chapter":
            $("label[for='title']").text('Book Title');
            break;
        case "conference_paper_or_proceeding":
            $("label[for='title']").text('Paper or Proceeding Title');
            break;
        case "presentation":
            $("label[for='title']").text('Presentation Title');
            break;
        case "other":
            $("label[for='title']").text('Publication Title');
            break;
        default:
            $("label[for='title']").text('Title');
            break;
    }

    // Set authors (field #4)
    switch (type) {
        case "journal_article":
            $("label[for='contactlist']").text('Article Author(s)');
            break;
        case "book_chapter":
            $("label[for='contactlist']").text('Chapter Author(s)');
            break;
        default:
            $("label[for='contactlist']").text('Author(s)');
            break;
    }

    // Set volume (field #13)
    switch (type) {
        case "journal_article":
            $("label[for='volume']").text('Journal Volume');
            break;
        case "book":
        case "book_chapter":
            $("label[for='volume']").text('Book Volume');
            $(".webform_element_volume .help-block").text('The book volume number, if applicable.').show();
            break;
        default:
            $("label[for='volume']").text('Volume');
            $(".webform_element_volume .help-block").hide();
            break;
    }

    // Set publication_date (field #16) and publication_location (field #18)
    switch (type) {
        case "conference_paper_or_proceeding":
        case "presentation":
            $("label[for='publication_date']").text('Conference Date');
            $("label[for='publication_location']").text('Conference Location');
            $(".webform_element_publication_location .help-block").text('The city and country where the conference was held.');
            $(".webform_element_publication_date, .webform_element_publication_location").css('display', '').removeClass('show_if_published');
            break;
        default:
            $("label[for='publication_date']").text('Publication Date');
            $("label[for='publication_location']").text('Publication Location');
            $(".webform_element_publication_location .help-block").text('The city and country of publication.');
            $(".webform_element_publication_date, .webform_element_publication_location").addClass('show_if_published');
            break;
    }

    // Set publication_identifier field attributes (for websites)
    switch (type) {
        case "website":
            $("label[for='publication_identifier']").text('URL');
            $(".webform_element_publication_identifier .help-block").html('URL of the website.');
            $('#publication_identifier').attr('placeholder', 'E.g. http://www.example.com/');
            break;
        default:
            $("label[for='publication_identifier']").text('Publication Identifier');
            $(".webform_element_publication_identifier .help-block").html('Optional unless published.');
            $('#publication_identifier').attr('placeholder', '');
            break;
    }

}

function onReadyModulePublications() {
    let jType = $('#type');
    jType.change(function() {
        publicationArrangeFields(Util.makeBareSlug(jType.val()));
        publicationModifyFields(Util.makeBareSlug(jType.val()));
        Util.setupLabelPositionAdjuster();
    });
    jType.change();
    let jWebform = $('.webform');
    $('.show_if_accepted, .show_if_awaiting, .show_if_published', jWebform).css('display', 'none');
    $('#status').change(function() {
        jWebform
            .addClass('not_published')
            .removeClass('published')
            .removeClass('awaiting')
            .removeClass('accepted');
        switch (Util.makeBareSlug($('#status').val())) {
            case 'published': // published
                jWebform
                    .addClass('published')
                    .removeClass('not_published');
                break;
            case 'awaiting_publication': // awaiting
                jWebform.addClass('awaiting');
                break;
            case 'accepted': // accepted
                jWebform.addClass('accepted');
                break;
            default:
                break;
        }
    }).change();

    $('td.webform_table_element_is_complete').each(function() {
        let is_complete = $(this).html();
        if (is_complete == 1) {
            $(this).html('<span class="glyphicon glyphicon-ok text-success center-block"></span>');
        } else {
            $(this).html('No');
        }
    });

    // Assign completion handles to the designated fields.
    Util.assignCompletion(['title', 'chapter_title'], 'publications')
}

function setupModule(module_slug, is_subform) {
    if (module_slug === 'background') { onReadyModuleBackground() }
    if (module_slug === 'publications') { onReadyModulePublications() }
    if (module_slug === 'ip') { onReadyModuleIP() }
    if (module_slug === 'proposals') { onReadyModuleProposals() }
    if (module_slug === 'researchers') {
        if (is_subform) {
            onReadyResearchersSubform();
        }
    }

    $('.webform .webform_element_type_checkboxes:not(.single) > label').append('<br><span class="apply">(select all that apply)</span>');

    Util.setupLabelPositionAdjuster(); // Must be after module loaders, as they may change label contents
}

/**********************************************************
 * Intellectual Property Module
 **********************************************************/

function ipModifyFields(type)
{
    // Set title (field #1)
    switch (type) {
        case "patent":
            $("label[for='title']").text('Patent Title');
            break;
        case "invention":
            $("label[for='title']").text('Invention Title');
            break;
        case "license":
            $("label[for='title']").text('License Title');
            break;
        default:
            $("label[for='title']").text('Title');
            break;
    }

    // Set description (field #3)
    switch (type) {
        case "patent":
            $("label[for='description']").text('Patent Abstract');
            break;
        case "invention":
            $("label[for='description']").text('Invention Description');
            break;
        default:
            $("label[for='description']").text('Description');
            break;
    }

    // Set status (field #5)
    switch (type) {
        case "license":
            $("label[for='status']").text('License Status');
            break;
        default:
            $("label[for='status']").text('Status');
            break;
    }
}

function onReadyModuleIP() {
    let jType = $('#type');
    jType.change(function() {
        ipModifyFields(Util.makeBareSlug(jType.val()));
        Util.setupLabelPositionAdjuster();
    });
    jType.change();
    $('#status').change(function() {
        switch (Util.makeBareSlug($('#status').val())) {
            case 'granted': // granted
                $('.webform').removeClass('not_granted');
                break;
            default:
                $('.webform').addClass('not_granted');
                break;
        }
    }).change();

    $('#invention_disclosure').change(function() {
        switch ($('#invention_disclosure').val()) {
            case "1": // disclosure
                $('.webform').removeClass('not_disclosure');
                break;
            default:
                $('.webform').addClass('not_disclosure');
                break;
        }
    }).change();

    // Assign completion handles to the designated fields.
    Util.assignCompletion(['title'], 'ip')
}

/**********************************************************
 * Proposals Module
 **********************************************************/

function onReadyModuleProposals() {
    // Assign completion handles to the designated fields.
    Util.assignCompletion(['proposal_title'], 'proposals');

    // Recommended for full-proposal enabled only for pre-proposals
    setStatusOptionsForProposalType();

    // If name funding_agency is a field
    let jFundingAgency = $("[name='funding_agency']");
    if (jFundingAgency.length) {
        // We want to clear nih_funding_mechanism and nsf_funding_mechanism if funding_agency is changed
        jFundingAgency.change(function() {
            $('#nih_funding_mechanisms').val(null).trigger('change')
            $('#nsf_funding_mechanisms').val(null).trigger('change')
        });
    }
}

function setStatusOptionsForProposalType() {
    $('#proposal_type').change(function() {
        switch (Util.makeBareSlug($(this).val())) {
            case 'pre_proposal': // published
                $('#status option[value="proposals_status----recommended"]').prop('disabled', false);
                break;
            case 'proposal':
                if ($('#status').val() == ('proposals_status----recommended')) {
                    $('#status option').prop('selected', false);
                    $('#status').val('');
                }
                $('#status option[value="proposals_status----recommended"]').prop('disabled', true);
                break;
        }
        reinitializeSelect2($('#status')); // update the changes to the initiatives in the select2
    });
}

/**********************************************************
 * OnReady Handler
 **********************************************************/

$(document).ready(function() {
    if (typeof window['route_module_slug'] !== 'undefined') {
        let module_slug = window['route_module_slug'];
        let is_subform = module_slug == window['route_subform_element'];
        preserveUnsavedState(() => setupModule(module_slug, is_subform));
    }
});

}
